import type { Incident } from '@analyzer/client';
import { useQuery } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';

export function useIncidentListQuery() {
  const client = useService();
  return useQuery<Incident[], Error>({
    queryKey: ['incident-list'],
    queryFn: () => client.incidentList(),
    keepPreviousData: true
  });
}
